import { Component, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Plugins } from "@capacitor/core";
import { ModalController } from "@ionic/angular";
import { IonicSelectableComponent } from "ionic-selectable";
import { Observable } from "rxjs";
import { Procedimento } from "src/app/models/procedimento.model";
import { Tipo } from "src/app/models/tipo.model";
import { ProcedimentosService } from "src/app/services/procedimentos.service";
import { TiposService } from "src/app/services/tipos.service";
const { Toast, Modals } = Plugins;

@Component({
  selector: "app-procedimento-modal",
  templateUrl: "./procedimento-modal.page.html",
  styleUrls: ["./procedimento-modal.page.scss"],
})
export class ProcedimentoModalPage implements OnInit {
  public tipos$: Observable<Tipo[]>;

  @Input() type: string;
  @Input() procedimento: Procedimento;
  modoEditar: boolean = false;
  formProcedimento: FormGroup;

  constructor(
    private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private service: ProcedimentosService,
    private tipoService: TiposService
  ) {
    this.tipos$ = this.tipoService.escutarMudancasTipo();
  }

  ngOnInit() {
    this.formulario();
    this.carregarTipos();
  }

  carregarTipos() {
    this.tipoService.getAll$();
  }

  formulario() {
    this.formProcedimento = this.formBuilder.group({
      nomeProced: new FormControl("", Validators.required),
      tipo: new FormControl("", Validators.required),
    });
    if (this.type === "editar") {
      this.modoEditar = true;
      this.formProcedimento
        .get("nomeProced")
        .setValue(this.procedimento.nomeProced);
      this.formProcedimento.get("tipo").setValue(this.procedimento.tipo);
    }
  }

  editar(procedimento: Procedimento) {
    const updatedProcedimento = new Procedimento().deserialize({
      ...this.procedimento,
      nomeProced: procedimento.nomeProced,
      tipo: procedimento.tipo,
    });
    this.service.edit(updatedProcedimento).subscribe(
      async () => {
        await Toast.show({
          text: `${procedimento.nomeProced} atualizada.`,
          duration: "long",
        });
      },
      async (erro) => {
        await Modals.alert({
          title: "Erro",
          message: `${erro.error.message}`,
        });
      },
      () => {
        this.fecharJanela();
      }
    );

    async (error) => {
      await Modals.alert({
        title: "Erro",
        message: `${error.error.message}`,
      });
    };
  }

  salvar(procedimento: Procedimento) {
    this.service.create(procedimento).subscribe(
      async () => {
        await Toast.show({
          text: `Novo procedimento ${procedimento.nomeProced} criado.`,
          duration: "long",
        });
      },
      async (error) => {
        await Modals.alert({
          title: "Erro",
          message: `${error.error.message}`,
        });
      },
      () => {
        this.fecharJanela();
      }
    );
    async (error) => {
      await Modals.alert({
        title: "Erro",
        message: `${error.error.message}`,
      });
    };
  }

  fecharJanela() {
    this.modalCtrl.dismiss({
      dissmissed: true,
    });
  }
}
